import { AUTHORITIES } from 'app/config/constants';
import PrivateRoute from 'app/shared/auth/private-route';
import React from 'react';
import { Switch } from 'react-router-dom';
import Company from './company';
import CompanyDeleteDialog from './company-delete-dialog';
import CompanyDetail from './company-detail';
import { CompanyUpdate } from './company-update';

const Routes = ({ match }) => (
  <>
    <Switch>
      <PrivateRoute
        exact
        path={`${match.url}/new`}
        component={CompanyUpdate}
        hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.REPRESENTATIVE_ADMIN, AUTHORITIES.MANUFACTURER_ADMIN]}
      />
      <PrivateRoute
        exact
        path={`${match.url}/:id/edit`}
        component={CompanyUpdate}
        hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.REPRESENTATIVE_ADMIN, AUTHORITIES.TRANSPORTER_ADMIN, AUTHORITIES.MANUFACTURER_ADMIN]}
      />
      <PrivateRoute
        exact
        path={`${match.url}/:id`}
        component={CompanyDetail}
        hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.REPRESENTATIVE_ADMIN, AUTHORITIES.TRANSPORTER_ADMIN, AUTHORITIES.MANUFACTURER_ADMIN]}
      />
      <PrivateRoute
        path={match.url}
        component={Company}
        hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.REPRESENTATIVE_ADMIN, AUTHORITIES.TRANSPORTER_ADMIN, AUTHORITIES.MANUFACTURER_ADMIN]}
      />
    </Switch>
    <PrivateRoute
      exact
      path={`${match.url}/:id/delete`}
      component={CompanyDeleteDialog}
      hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.REPRESENTATIVE_ADMIN]}
    />
  </>
);

export default Routes;
